module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-intro border-bottom padding-bottom"
  }, [_c('div', {
    staticClass: "main-area padding-top single-content"
  }, [(_vm.location["verdieping-mapping"] || _vm.location["verdieping-programma"] || _vm.location["verdieping-links-naar-meer"] || _vm.location["verdieping-archief"] || _vm.location["verdieping-essays"] || _vm.location["verdieping-klankbordgroep"]) ? _c('router-link', {
    staticClass: "strong",
    attrs: {
      "to": {
        name: 'verdieping',
        params: {
          language: _vm.language
        }
      }
    }
  }, [(_vm.language === "nl") ? _c('span', [_vm._v("< Verdieping")]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', [_vm._v("< Context")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && _vm.loaded.posts) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.introNL)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.loaded.posts) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.introEN)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location.programma && "loaded.filters") ? _c('div', {
    staticClass: "filters secondary-color large-text"
  }, [_c('div', {
    staticClass: "filter-item strong",
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Filter")]), _vm._v(" "), _vm._l((_vm.filters), function(item) {
    return _c('dsFilterItem', {
      staticClass: "filter-item",
      attrs: {
        "item": item,
        "language": _vm.language
      }
    })
  })], 2) : _vm._e()], 1), _vm._v(" "), (_vm.screenSize.mobile === false && _vm.loaded.tags) ? _c('dsTags', {
    staticClass: "secondary-area",
    attrs: {
      "language": _vm.language,
      "tags": _vm.tags
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9b9ae9c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsSectionIntro.vue
// module id = 224
// module chunks = 2